import { LOCALE_DE, LOCALE_EN } from '@config/app.constants';

// TODO: Moved from src/,  This file needs a full refactoring
export const SUPPORTED_LANGUAGES = [LOCALE_DE, LOCALE_EN];

type XTSNavigator = typeof window.Navigator & {
  userLanguage?: string;
  language?: string;
};

export const languageFromBrowser = () => {
  const navigator: XTSNavigator = window.Navigator;
  const defaultLanguage = 'de';
  const browserLanguage = (
    navigator?.language || navigator?.userLanguage
  )?.split('-')[0];

  return SUPPORTED_LANGUAGES.indexOf(browserLanguage) >= 0
    ? browserLanguage
    : defaultLanguage;
};

export const getLocaleId = () => {
  // @ts-ignore
  const { language } = window._hopsServerData;

  return language === 'de' ? 'de' : 'en';
};
